import { Button, Menu } from "antd";
import AuthHelper from "components/auth/helpers";
import { useEffect, useState } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import style from "./style.module.css";
import { useTranslation } from "react-i18next";
import EnvironmentSwitch from "../environment-switch";
import { useAppSelector } from "redux/hooks";
import { WHITELABEL } from "utils/Constants";

export type SubMenuPropType = {
  navItem: any;
  collapsed?: boolean;
};

const SubMenus: React.FC<SubMenuPropType> = ({ navItem, collapsed }) => {
  const whitelabel = useAppSelector(state => state.properties.whiteLabel);
  const history = useHistory();
  const { t } = useTranslation();
  const location = useLocation();
  const [current, setCurrent] = useState(location.pathname);

  useEffect(() => {
    if (location) {
      if (current !== location.pathname) {
        setCurrent(location.pathname);
      }
    }
  }, [location, current]);

  const handleMenuClick = (e: any) => {
    setCurrent(e.key);
  };

  const logOut = () => {
    history.push("/");
    if (current !== String(history.location.pathname)) {
      AuthHelper.clearAuth();
      history.go(0);
    }
  };

  const menuItems = navItem.map((nav: any) => {
    const { Icon } = nav;
    const title = t(nav.title);
    if (nav.isLogout) {
      return {
        key: "logout",
        label: (
          <Button className={style.item} key={`${nav?.url}`} onClick={() => logOut()}>
            <div className="sr-only">Logout</div>
            <div className={style.button}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ marginRight: 8 }}>
                  <Icon alt="" aria-hidden={true} />
                </div>{" "}
                <div>{title}</div>
              </div>
            </div>
          </Button>
        )
      };
    } else if (nav.isDivider) {
      return {
        key: "logout",
        type: "divider"
      };
    } else {
      return {
        key: nav?.url,
        label: (
          <div className={style.item} key={`${nav?.url}`}>
            <div className={style.button}>
              <NavLink
                to={nav?.url}
                style={{ display: "flex", alignItems: "center" }}
                exact={true}
                isActive={() => {
                  return window.location.pathname === nav.url;
                }}
              >
                <div style={{ marginRight: 8 }} aria-hidden={true}>
                  <Icon alt="" aria-hidden={true} />
                </div>{" "}
                {collapsed ? <div className="sr-only">{title}</div> : <span>{title}</span>}
              </NavLink>
            </div>
          </div>
        )
      };
    }
  });
  return (
    <nav>
      {whitelabel === WHITELABEL.uac && (
        <div
          style={
            collapsed
              ? {
                  paddingTop: 16,
                  paddingBottom: 0,
                  paddingLeft: 8,
                  paddingRight: 8
                }
              : { paddingTop: 16, paddingBottom: 0, paddingLeft: 24, paddingRight: 24 }
          }
        >
          <EnvironmentSwitch collapsed={collapsed} />
        </div>
      )}
      <Menu
        mode="inline"
        selectedKeys={[current]}
        onClick={handleMenuClick}
        className={style.menu}
        items={menuItems}
      />
    </nav>
  );
};

export default SubMenus;
